import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, ENVIRONMENT } from '@environment-token';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient, @Inject(ENVIRONMENT) private env: Environment) {}

  getSessionStatistics(startDate: number, endDate: number): Observable<any> {
    const httpOptions = {
      params: new HttpParams().set('startDate', startDate.toString()).set('endDate', endDate.toString()),
    };

    return this.http.get(`${this.env.API.orchestrator_analysis}/home/sessions`, httpOptions);
  }

  getTrainingStatistics(startDate: number, endDate: number): Observable<any> {
    const httpOptions = {
      params: new HttpParams().set('startDate', startDate.toString()).set('endDate', endDate.toString()),
    };

    return this.http.get(`${this.env.API.orchestrator_analysis}/home/conversation/training`, httpOptions);
  }

  getConversationsStatistics(startDate: number, endDate: number, tags?: string): Observable<any> {
    const httpOptions = {
      params: new HttpParams().set('startDate', startDate.toString()).set('endDate', endDate.toString()).set('fillEmptyDate', 'true'),
    };
    if (tags) httpOptions.params = httpOptions.params.append('tags', tags);

    return this.http.get(`${this.env.API.orchestrator_analysis}/home/generic/conversations`, httpOptions);
  }
}
